import { Button } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface FloatingButtonsContainerProps {
  isStatic?: boolean;
}

const shouldForwardProp = (prop: PropertyKey) =>
  !['isActive', 'textColor', 'isAbsolute', 'isStatic'].includes(prop as string);

export const FloatingButtonsContainer = styled(Box, {
  shouldForwardProp,
})<FloatingButtonsContainerProps>(({ theme, isStatic }) => ({
  padding: theme.spacing(0.75, 1),
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  backgroundColor: '#F3F3F3',
  position: 'absolute',
  bottom: theme.spacing(1.25),
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: theme.zIndex.fab,
  ...(isStatic && {
    position: 'static',
    transform: 'none',
    width: 'fit-content',
  }),
}));

interface FloatingButtonProps {
  isActive?: boolean;
  textColor?: string;
}

export const FloatingButton = styled(Button, {
  shouldForwardProp,
})<FloatingButtonProps>(({ theme, isActive, textColor }) => ({
  height: '44px',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  padding: theme.spacing(1.25),
  borderRadius: theme.spacing(0.5),
  backgroundColor: isActive
    ? theme.palette.common.white
    : theme.palette.mode === 'dark'
    ? theme.palette.grey[800]
    : theme.palette.grey[200],
  color: isActive ? textColor : theme.palette.text.secondary,
  border: isActive ? `1px solid ${theme.palette.divider}` : `1px solid transparent`,
  '&:hover': {
    backgroundColor: theme.palette.common.white,
    filter: 'brightness(0.8)',
  },
}));
